var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import CMSTouchPanel from '../CMSTouchPanel';
import GFCSTouchPanel from '../GFCSTouchPanel';
var isCMSLayout = function (layoutId) { return layoutId === 'cms'; };
export default function TouchPanel(props) {
    return isCMSLayout(props.layoutId) ? (React.createElement(CMSTouchPanel, __assign({}, props))) : (React.createElement(GFCSTouchPanel, __assign({}, props)));
}
//# sourceMappingURL=index.js.map